import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { faCalendarPlus } from '@fortawesome/pro-light-svg-icons';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons';
import { faLocationDot } from '@fortawesome/pro-light-svg-icons';
import { faTv } from '@fortawesome/pro-light-svg-icons';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import { faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { faBars } from '@fortawesome/pro-regular-svg-icons';

import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faVimeoV } from '@fortawesome/free-brands-svg-icons';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';


library.add(faAngleDown, faCalendar, faCalendarPlus, faLocationDot, faTv, faMagnifyingGlass, faChevronLeft, faChevronRight, faArrowUpRightFromSquare, faBars, faXmark, faInstagram, faXTwitter, faFacebookF, faYoutube, faVimeoV, faLinkedinIn);
dom.watch();

import '@/sass/style.scss'
